﻿import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'dialog-box',
    templateUrl: 'dialog-box.component.html'
})
export class DialogBoxComponent {

    @Input() header;
    @Input() message;
    @Input() hidden = true;

    @Output() input: EventEmitter<boolean> = new EventEmitter();

    get displayStyles() {
        if (this.hidden) {
            return {
                display: 'none',
                backgroundColor: 'rgba(0,0,0,0.5)',
            };
        } else {
            return {
                display: 'block',
                backgroundColor: 'none',
            };
        }
    }

    save() {
        this.input.emit(true);
    }

    dismiss() {
        this.input.emit(false);
    }
}
